import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  assignOfficeStaffToDso,
  deleteOfficeStaffFromDso,
} from '../../../../../../../actions/staffActions';

export const useAssignToDso = () => {
  const dispatch = useDispatch();

  const dso = useSelector((state) => state.staff.dso.details);
  const staffDetails = useSelector((state) => state.staff.staffDetails);

  const handleAssignDso = useCallback(
    (option) => {
      if (option.id) {
        dispatch(assignOfficeStaffToDso({ dsoId: option.id, staffId: staffDetails.id }));
        return;
      }

      dispatch(deleteOfficeStaffFromDso({ dsoId: dso?.id, staffId: staffDetails.id }));
    },
    [dispatch, dso?.id, staffDetails.id],
  );

  return {
    handleAssignDso,
  };
};
